const shippingFeesConstant = {
  RECEIVE_SHIPPING_DATA: 'RECEIVE_SHIPPING_DATA',
  RECEIVE_SHIPPING_FAIL: 'RECEIVE_SHIPPING_FAIL',
  RECEIVE_AD_SHIPPING_DATA: 'RECEIVE_AD_SHIPPING_DATA',
  RECEIVE_AD_SHIPPING_FAIL: 'RECEIVE_AD_SHIPPING_FAIL',
};

export default shippingFeesConstant;
